/**
 * @generated SignedSource<<387a395668a8f8986a97ae76047df2b0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type name_projectVersions_NameCell_jiraProject$data = {
  readonly key: string;
  readonly projectType: JiraProjectType;
  readonly " $fragmentType": "name_projectVersions_NameCell_jiraProject";
};
export type name_projectVersions_NameCell_jiraProject$key = {
  readonly " $data"?: name_projectVersions_NameCell_jiraProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"name_projectVersions_NameCell_jiraProject">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "name_projectVersions_NameCell_jiraProject",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "key"
      },
      "action": "THROW",
      "path": "key"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "projectType"
      },
      "action": "THROW",
      "path": "projectType"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "a64f354b68d1237c5efb3aba5192d28c";

export default node;
